// CHF totals, charged once per selected period. Discounts apply on every renewal.
export const BILLING_PERIODS = ['monthly', 'semiannual', 'annual']
const MONTHS_PER_PERIOD = { monthly: 1, semiannual: 6, annual: 12 }
export const BILLING_PRICES = {
  basic: { monthly: 19, semiannual: 95, annual: 171, annualRenewal: 171 },
  premium: { monthly: 39, semiannual: 195, annual: 351, annualRenewal: 351 },
}
export const subscriptionOffersEnabled = process.env.REACT_APP_SUBSCRIPTION_OFFERS_ENABLED === 'true'
export function offerFor(plan, period = 'monthly') {
  if (!BILLING_PERIODS.includes(period) || !BILLING_PRICES[plan]) return null
  const prices = BILLING_PRICES[plan]
  return { plan, period, amount: prices[period], renewal: period === 'annual' ? prices.annualRenewal : prices[period] }
}

export function savingsAmount(plan, period, renewal = false) {
  const offer = offerFor(plan, period)
  if (!offer || period === 'monthly') return 0
  const months = MONTHS_PER_PERIOD[period]
  const reference = BILLING_PRICES[plan].monthly * months
  return reference - (renewal ? offer.renewal : offer.amount)
}

export function savingsPercent(plan, period, renewal = false) {
  const saved = savingsAmount(plan, period, renewal)
  if (!saved) return 0
  const months = MONTHS_PER_PERIOD[period]
  return Math.round(saved / (BILLING_PRICES[plan].monthly * months) * 100)
}

export function monthlyEquivalent(plan, period, renewal = false) {
  const offer = offerFor(plan, period)
  return offer ? (renewal ? offer.renewal : offer.amount) / MONTHS_PER_PERIOD[period] : 0
}

// Express the discount in full-price monthly payments; subscription duration is unchanged.
export function equivalentFreeMonths(plan, period, renewal = false) {
  return BILLING_PRICES[plan] ? savingsAmount(plan, period, renewal) / BILLING_PRICES[plan].monthly : 0
}

export function formatChf(amount, lang = 'fr') {
  if (Number.isInteger(amount)) return `CHF ${amount}.–`
  return `CHF ${new Intl.NumberFormat(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)}`
}

// Monetary comparisons use each currency's minor unit (e.g. JPY 0, CHF/EUR 2, KWD 3).
export function formatCurrency(amount, currency = 'CHF', lang = 'fr') {
  return currency === 'CHF' ? formatChf(amount, lang)
    : new Intl.NumberFormat(lang, { style: 'currency', currency, currencyDisplay: 'code' }).format(amount)
}

export function storeSavings(amount, monthlyAmount, currency, months) {
  if (!currency || !Number.isFinite(amount) || !Number.isFinite(monthlyAmount) || amount <= 0 || monthlyAmount <= 0 || months <= 1) return null
  const factor = 10 ** new Intl.NumberFormat('en', { style: 'currency', currency }).resolvedOptions().maximumFractionDigits
  const total = Math.round(amount * factor), monthly = Math.round(monthlyAmount * factor)
  const saved = monthly * months - total
  if (monthly <= 0 || saved <= 0) return null
  const freeMonths = Math.floor(saved / monthly)
  return { saved: saved / factor, percent: Math.round(saved / (monthly * months) * 100), freeMonths,
    extraSaved: (saved - freeMonths * monthly) / factor, equivalentMonths: saved / monthly }
}
